import { createStore } from "vuex";
import { API_KEYS } from "@/assets/api_constants";
import * as common from "@/assets/common/common";
import { Member } from "@/model/member";
import { OrgUser } from "@/model/organization";

interface RootState {
  isLoggedin: boolean;
  isOrgUser: boolean;
  loggedInUserId: string | null;
  loggedInUserName: string | null;
}

const store = createStore<RootState>({
  state: {
    isLoggedin: false,
    isOrgUser: false,
    loggedInUserId: null, // 초기값을 null로 설정
    loggedInUserName: null, // 초기값을 null로 설정
  },
  mutations: {
    setAuthInfo(state, info: Member | OrgUser) {
      if (info && Object.keys(info).length > 0) {
        if ("orgId" in info) {
          state.isOrgUser = true;
        } else {
          state.isOrgUser = false;
        }
        localStorage.setItem("auth", JSON.stringify(info));
        if (
          "orgId" in info &&
          (info.type === "admin" || info.type === "user")
        ) {
          state.loggedInUserId = info.uid;
        } else {
          if (info.type === "custom") {
            const customUID = info.uid.includes("#")
              ? info.uid.split("#")[1]
              : info.uid;
            const realUID = customUID.includes(":")
              ? customUID.split(":")[1]
              : customUID;
            if (info.name) {
              state.loggedInUserId = realUID;
              state.loggedInUserName = info.name;
            } else {
              state.loggedInUserId = realUID;
            }
          } else {
            // SNS
            state.loggedInUserId = info.name || info.email || "이름없음";
          }
        }

        state.isLoggedin = true;
      } else {
        state.isOrgUser = false;
        state.loggedInUserId = null;
        localStorage.removeItem("auth");
        state.isLoggedin = false;
      }
    },
  },
  actions: {
    fetchLoginInfo({ commit }) {
      const loginInfo = common.getLocalAuth();
      commit("setAuthInfo", loginInfo);
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.isLoggedin,
  },
});

export default store;
